angular.module('App.video.recruiter.router', []);